import { imageTypes } from 'corso-types';
import Submit from '~/components/button/Submit';
import Form from '~/components/Form';
import Field from '~/components/form-controls/Field';

import FileUploader from '~/components/form-controls/FileUploader';
import TextArea from '~/components/form-controls/TextArea';
import Page from '~/components/layout/page/Page';
import { useActionResult, useLoaderData } from './shippingClaimMeta';

export default function ShippingClaimMetaPage() {
  const { uploadFileInfo, ...values } = useLoaderData();
  const actionResult = useActionResult();

  return (
    <Page.Root title="Anything else you can tell us?">
      <Form encType="multipart/form-data">
        <TextArea
          id="noteFromCustomer"
          name="noteFromCustomer"
          label="Additional comments"
          defaultValue={values.noteFromCustomer}
        />

        {uploadFileInfo && (
          <FileUploader
            label="Upload Images"
            accept={imageTypes}
            name="assets"
            min={uploadFileInfo.requiredImgUploadCount}
            defaultValue={values.assets}
            description="Please upload clear images indicating damaged items."
            destination={uploadFileInfo.destination}
            storefrontId={uploadFileInfo.storefrontId}
          />
        )}

        {actionResult?.ok === false && (
          <Field.ErrorText>{actionResult.message}</Field.ErrorText>
        )}
        <Submit>Next</Submit>
      </Form>
    </Page.Root>
  );
}
